import React from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";

const DesktopNav = ({ navLinks, isActive, dropdownOpen, setDropdownOpen }) => (
  <div className="hidden lg:flex items-center gap-1">
    {navLinks.map((link) => (
      <div
        key={link.name}
        className="relative"
        onMouseEnter={() => (link.children || link.groups) && setDropdownOpen(link.name)}
        onMouseLeave={() => setDropdownOpen(null)}
      >
        <Link
          to={link.path}
          className={`px-4 py-2 text-sm font-medium transition-all duration-300 rounded-md flex items-center gap-1 ${
            isActive(link.path)
              ? "text-[#1B2A4A] bg-[#1B2A4A]/5"
              : "text-gray-600 hover:text-[#1B2A4A] hover:bg-gray-50"
          }`}
        >
          {link.name}
          {(link.children || link.groups) && (
            <ChevronDown
              size={14}
              className={`transition-transform duration-300 ${
                dropdownOpen === link.name ? "rotate-180" : ""
              }`}
            />
          )}
        </Link>

        {/* Simple dropdown */}
        {link.children && dropdownOpen === link.name && (
          <div className="absolute top-full left-0 mt-1 w-56 bg-white rounded-lg shadow-xl border border-gray-100 py-2 animate-fadeIn z-50">
            {link.children.map((child) => (
              <Link
                key={child.name}
                to={child.path}
                className="block px-4 py-2.5 text-sm text-gray-600 hover:text-[#1B2A4A] hover:bg-[#1B2A4A]/5 transition-colors"
              >
                {child.name}
              </Link>
            ))}
          </div>
        )}

        {/* Mega-menu with groups */}
        {link.groups && dropdownOpen === link.name && (
          <div
            className="absolute top-full left-0 mt-1 bg-white rounded-xl shadow-xl border border-gray-100 py-5 px-2 animate-fadeIn z-50 flex gap-2"
            style={{ minWidth: `${link.groups.length * 180}px` }}
          >
            {link.groups.map((group) => (
              <div key={group.title} className="px-3 min-w-[160px]">
                <div className="text-[10px] font-bold text-[#C9A96E] uppercase tracking-[0.15em] mb-2 px-1">
                  {group.title}
                </div>
                {group.items.map((item) => (
                  <Link
                    key={item.name}
                    to={item.path}
                    className="block px-2 py-2 text-sm text-gray-600 hover:text-[#1B2A4A] hover:bg-[#1B2A4A]/5 rounded-md transition-colors"
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    ))}
  </div>
);

export { DesktopNav };
